import { privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { Coach } from "../models";

export const getCoaches = async () => {
  const { data } = await privateAPI.get<ServiceResponse<Coach[]>>(
    `/coaching-admin/coaches`,
  );

  return data.data;
};
